import { Box, SxProps, Theme, Typography } from '@mui/material';

import { AppIcon } from '../designSystem/icons/AppIcon';

type CheckListLineItemProps = Readonly<{
  title: string;
  description: string;
  bottomBorder: boolean;
  onClick?: () => void;
}>;

export const CheckListLineItem = ({
  title,
  description,
  bottomBorder,
  onClick,
}: CheckListLineItemProps) => {
  return (
    <Box onClick={onClick} sx={listItemStyle(bottomBorder)}>
      <Box sx={textContainerStyle}>
        <Typography
          variant="text-md-medium"
          color={({ backrs }) => backrs.colors['Colors/Text/text-primary']}
        >
          {title}
        </Typography>
        <Typography
          variant="text-sm-regular"
          color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
        >
          {description}
        </Typography>
      </Box>
      <Box sx={iconContainerStyle}>
        <AppIcon iconName="ArrowCircleRight" diameter="32px" color="currentColor" thin />
      </Box>
    </Box>
  );
};

const listItemStyle =
  (bottomBorder: boolean): SxProps<Theme> =>
  ({ backrs }) => ({
    borderBottom: bottomBorder
      ? `1px solid ${backrs.colors['Colors/Border/border-secondary']}`
      : 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: ({ backrs }) => backrs.spacing['spacing-2xl'],
    py: ({ backrs }) => backrs.spacing['spacing-2xl'],
    cursor: 'pointer',
  });

const textContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const iconContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
